var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "14px",
    viewBox: "0 0 20 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-MyClients-planningList-SingleActivity",
    transform: "translate(-1149.000000, -299.000000)",
    stroke: "#646464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(1130.000000, 190.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(20.000000, 107.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,5.78571429 C0,5.78571429 4.05,0 9,0 C13.8857143,0 18,5.78571429 18,5.78571429 C18,5.78571429 13.8857143,11.5714286 9,11.5714286 C4.11428571,11.5714286 0,5.78571429 0,5.78571429 L0,5.78571429 Z",
    id: "Stroke-298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,2.57142857 C10.7749286,2.57142857 12.2142857,4.01078571 12.2142857,5.78571429 C12.2142857,7.56064286 10.7749286,9 9,9 C7.22507143,9 5.78571429,7.56064286 5.78571429,5.78571429 C5.78571429,4.01078571 7.22507143,2.57142857 9,2.57142857 L9,2.57142857 Z",
    id: "Stroke-299"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcView);
export default __webpack_public_path__ + "static/media/ic-view.844a95280b9612899e2a71f2d6447281.svg";
export { ForwardRef as ReactComponent };